import {Injectable} from '@angular/core';
import {CPCUser} from './login/CPCUser';
import {Subject} from 'rxjs/Subject';
import {CpcWebApiService} from './cpc-web-api.service';
// tslint:disable
@Injectable()
export class CpcSysInfoService {

  /** 用户对象 */
  public userInfo = new CPCUser();
  /** 系统信息 */
  public systemInfo = {
    productdesc: ''
  };

  /** entCode */
  public entId: number;
  public entCode: string;

  /** 系统参数 */
  public sysConf;
  /** 个人参数 */
  public userConf;
  public logoUrl; // 登陆以后左上角的logo的图片的url
  public title:any=''; // 浏览器标签页的title，和 左上角的title；
  public loginlogourl; // 登录界面左边的logo；
  public openFileStyle; // 根据个人参数设置 0 文档先下载到本地，在打开 1 直接打开，不需要下载
  /*使用的语言*/
  public browserLang: Subject<any> = new Subject(); // 订阅
  public _browserLang = 'zh'; // 浏览器默认语言  存放当前用户使用的是哪种语言
  public langId = '1'; // langid用来匹配字段
  /*个性主题 */
  public styleColor: Subject<any> = new Subject(); // 颜色
  public styleFont: Subject<any> = new Subject(); // 字体
  // 系统参数 定义大模块和选中模块的颜色
  public X6LeftBarBackgroundColorOfSys: String = '';
  /* 隐藏header*/
  public hideTop: Subject<any> = new Subject();
  /* 全屏*/
  public fullscreen: Subject<any> = new Subject();
  /* 菜单展示方式*/
  // normal/tree /panel/float
  // float  鼠标悬停在上面就 展示 子模块和 菜单，不需要点击
  public menuStyle = '';
  public ModMenuStyle = '';
  public IsSpread = '';

  /*left-menu颜色*/
  public color: string = '';
  public subSysConf: Subject<any> = new Subject();  // 从后台获取到系统参数后推送给需要用到系统参数的组件
  public subUserConf: Subject<any> = new Subject(); // 从后台获取到用户参数后推送...

  public subWFUpdate: Subject<any> = new Subject(); // 更新待办流程数据，使用时推送'wfupdate'(区分大小写)，会更新角标上待办数量，以及已打开的待办流程列表
  public subWFListUpdate: Subject<any> = new Subject(); // 更新待办流程列表，使用时推送'wflistupdate'(区分大小写)，会更新待办流程列表
  public subEmailRefresh: Subject<any> = new Subject(); // 更新邮件数量角标,使用时推送'emailrefresh'(区分大小写)
  public subAboutEmail: Subject<any> = new Subject(); // 关于邮件的操作推送
  // webtool 下载路径
  webtoolURL: string = '';
  //
  useFontJudgeOnly: string = '';
  AutoDispModIds: String = ''; // 打开时自动加载的模块
  HideHomePage: String = ''; // 是否隐藏首页，1隐藏
  InitRevLabel: string = ''; // 上传文件初始化的revLabel 登录组件初始化
  SinoccSSoCode: string = ''; // 上
  licenseduehint: string = ''; // 授权到期提示
  //多语言，支持的语言种类，
  public langs = [];
  public UseFdrMaxSpace: string = ''; // 录入文档是否限制大小。
  public getSysConf(confname): string {
    for (let i = 0; i < this.sysConf.length; i++) {
      if (this.sysConf[i].confname == confname) {
        return this.sysConf[i].confvalue;
      }
    }
    return '';
  }

  public dbtype: Number = 1; // 数据库类型
  /**
   * 初始化系统参数与个人参数(仅在登录时调用)
   * @param sysConf
   */
  initSysInfo() {
    let data = {
      conftype: 1 //取参数类型:0-系统,1-系统+个人,2-个人
    };
    this.webapi.post('cpcwebuser', 'getconfvalue', data).then(response => {
      const rdata = response.json();

      //设置用户角色信息
      this.userInfo.roleOfUsers = rdata.roleofuser;
      this.userInfo.HomePageUrl = rdata.homepageurl;

      //设置系统参数
      this.sysConf = rdata.sysconfofusers;
      this.systemInfo.productdesc = this.getSysConf('productdesc');
      this.subSysConf.next(this.sysConf);


      //设置个人参数
      this.userConf = rdata.userconfofusers;
      this.subUserConf.next(this.userConf);

      //根据系统参数设置标签页标题
      // document.title = this.getSysConf("productdesc");


    }, error => {
      console.log(error);
    });
  }
  // 模块或者菜单里面是 定义了<XXX> 需要替换 成实际的数据
///<USERID> ,<USERNAME> ,<ENTID>
  setCellDefValue(str) {

    if (/<USERID>/i.test(str)) {
      str = str.replace(/<USERID>/ig, this.userInfo.userId);
    }
    if (/<USERNAME>/i.test(str)) {
      str = str.replace(/<USERNAME>/ig, this.userInfo.userName);
    }
    if (/<ENTID>/i.test(str)) {
      str = str.replace(/<ENTID>/ig, this.entId);
    }
    if (/<ENTCODE>/i.test(str)) {
      str = str.replace(/<ENTCODE>/ig, this.entCode);
    }
    // 外部系统的令牌 值是门户登录的存在window.sessionStorage中 司顺用到的
    if (/<EXTTOKEN>/i.test(str)) {
      str = str.replace(/<EXTTOKEN>/ig, window.sessionStorage.getItem('htaccesstoken3323')||'');
    }
    // 外部系统的令牌 值是门户登录的存在window.sessionStorage中
    if (/<SINOCCSSOCODE>/i.test(str)) {
      str = str.replace(/<SINOCCSSOCODE>/ig, this.SinoccSSoCode);
    }
    return str;
  }

  public appConfig = {
    screen: {
      width: 1920,
      height: 1080,
      scale: 21.6
    }
  };

  destroy() {
    this.userInfo = new CPCUser();
    this.systemInfo.productdesc = '';
    this.entId = null;
    this.entCode = null;
    this.sysConf = null;
    this.userConf = null;
    this.color = '';
    window.localStorage.removeItem('sysInfo');
  }


  constructor(
    public webapi: CpcWebApiService,
  ) {

  }

}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/cpc-sys-info.service.ts